/* eslint-disable camelcase */
import baseAxios, { AxiosInstance } from 'axios';
import qs from 'querystring';

import { getAccessToken, setAccessToken, setExpiredTime, setRefreshToken } from '../utils/storage';

interface TokenInfo {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

interface BaseAxios extends AxiosInstance {
  setToken?: (data?: TokenInfo) => void;
}

declare global {
  interface Window {
    REACT_APP_API_HOST: string;
  }
}

export const baseURL =
  window.REACT_APP_API_HOST ||
  process.env.REACT_APP_API_HOST ||
  `${window.location.protocol}//${window.location.host}`;

const axios: BaseAxios = baseAxios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => qs.stringify(params),
});

axios.setToken = (data?: TokenInfo) => {
  let token = getAccessToken();
  if (data) {
    const { access_token, refresh_token, expires_in } = data;
    token = access_token;
    setRefreshToken(refresh_token);
    setAccessToken(token);
    setExpiredTime(expires_in);
  }
  if (token) {
    axios.defaults.headers['Authorization'] = `Bearer ${token}`;
  }
};

export const encodeQueryData = (data = {}): string | undefined => {
  const ret = [];

  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (value && value !== '_all') {
      if (Array.isArray(value)) {
        if (key === 'sort') {
          value.forEach((sortVal) => {
            ret.push(`${encodeURIComponent(key)}=${sortVal}`);
          });
          return;
        }
        const values = value.map((x) => {
          return encodeURIComponent(x && x.value !== null && x.value !== undefined ? x.value : x);
        });
        ret.push(`${encodeURIComponent(key)}=${values.join(',')}`);
      } else {
        if (value && typeof value.getMonth === 'function') {
          value = value.toISOString(true);
        } else if (value && typeof value === 'string') {
          value = value.trim();
        }
        ret.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(
            value && value.value !== null && value.value !== undefined ? value.value : value
          )}`
        );
      }
    }
  });

  return ret.join('&');
};

const { get, post, put } = axios;
export { get, post, put, axios };
